import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMytaverseEvent } from '../../providers';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useStyles } from './styles';

const BrandingModeNotification = () => {
  const { t: translate } = useTranslation();
  const { isBrandingModeEnabled, setIsBrandingModeEnabled, setRoomSpots } =
    useMytaverseEvent();
  const { sendMessageToUnreal } = useMytaverse();
  const classes = useStyles();

  const handleExitBrandingMode = () => {
    setIsBrandingModeEnabled(false);
    setRoomSpots([]);
    sendMessageToUnreal({
      action: 'LEAVE_CUSTOMIZATION_MODE',
    });
  };

  if (!isBrandingModeEnabled) {
    return null;
  }

  return (
    <Box sx={classes.container}>
      <Typography sx={classes.text}>
        {translate('adminToolbox.brandingModeEnabled', 'Branding Mode Enabled')}
      </Typography>
      <Typography sx={classes.divider}>|</Typography>
      <Link
        component="button"
        onClick={handleExitBrandingMode}
        sx={classes.exitLink}
      >
        {translate('adminToolbox.exitBrandingMode', 'Exit branding mode')}
      </Link>
    </Box>
  );
};

export default BrandingModeNotification;
